const config = {
  aws: {
    region: process.env.REACT_APP_AWS_REGION,
    storage: {
      buckets: {
        audio: process.env.REACT_APP_AWS_S3_AUDIO_BUCKET,
        exerciseVideo: process.env.REACT_APP_AWS_S3_EXERCISE_VIDEO_BUCKET,
        image: process.env.REACT_APP_AWS_S3_IMAGE_BUCKET,
        video: process.env.REACT_APP_AWS_S3_VIDEO_BUCKET
      }
    }
  },
  sso: {
    url: process.env.REACT_APP_STJ_OIDC_URL,
    clientId: process.env.REACT_APP_STJ_OIDC_CLIENT_ID,
    redirectUri: process.env.REACT_APP_STJ_OIDC_REDIRECT_URI,
  },
  base_href: process.env.REACT_APP_BASE_HREF,
  cognito: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    appClientId: process.env.REACT_APP_APP_CLIENT_ID
  },
  api: {
    base: process.env.REACT_APP_API_BASE,
    csrfCookieName: process.env.REACT_APP_CSRF_COOKIE_NAME
  },
  googleAnalytics: {
    trackingId: process.env.REACT_APP_GA_TRACKING_ID
  },
  stripe: {
    apiKey: process.env.REACT_APP_STRIPE_API_KEY
  }
};

export default config;
